(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var v = document.querySelector('[data-hero-video]');
  if (!v) return;
  // Respect reduced motion: show the poster, don't play.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    v.removeAttribute('autoplay'); try { v.pause(); } catch (e) {}
    return;
  }
  // Ensure autoplay kicks in on browsers that need an explicit play() call.
  var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
  if (v.readyState >= 2) tryPlay(); else v.addEventListener('loadeddata', tryPlay, { once: true });
  // Pause when offscreen to save resources.
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) tryPlay(); else try { v.pause(); } catch (x) {} });
    }, { threshold: 0.1 }).observe(v);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  function change(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function () { window.location.reload(); });
  }
  document.querySelectorAll('[data-line-inc]').forEach(function (b) { b.addEventListener('click', function () { var l = b.closest('[data-line-key]'); change(b.dataset.key, parseInt(l.querySelector('[data-line-qty]').value, 10) + 1); }); });
  document.querySelectorAll('[data-line-dec]').forEach(function (b) { b.addEventListener('click', function () { var l = b.closest('[data-line-key]'); change(b.dataset.key, Math.max(0, parseInt(l.querySelector('[data-line-qty]').value, 10) - 1)); }); });
  document.querySelectorAll('[data-line-remove]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); change(b.dataset.key, 0); }); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  var root = document.currentScript && document.currentScript.closest ? document : document;
  var sortSel = document.querySelector('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(window.location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); window.location.href = u.toString();
  });
  var toggle = document.querySelector('[data-filter-toggle]');
  var panel = document.querySelector('[data-filters]');
  if (toggle && panel) toggle.addEventListener('click', function () {
    var on = panel.hasAttribute('hidden');
    if (on) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
    toggle.setAttribute('aria-expanded', String(on));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-finder]');
  if (!root) return;
  var steps = Array.prototype.slice.call(root.querySelectorAll('.finder__step'));
  var result = root.querySelector('[data-finder-result], .finder__result');
  var bar = root.querySelector('[data-finder-bar]');
  var stepNum = root.querySelector('[data-finder-step-num]');
  var back = root.querySelector('[data-finder-back]');
  var live = root.querySelector('[data-finder-live]');
  var total = steps.length;
  root.querySelector('[data-finder-step-total]').textContent = total;
  var answers = {};
  var cur = 0;

  var GEAR = {
    'outdoor-gear': { label: 'Outdoor Gear', url: '/collections/outdoor-gear' },
    'winter-sports': { label: 'Winter Sports', url: '/collections/winter-sports' },
    'rider-gear': { label: 'Bike & Motorcycle', url: '/collections/rider-gear' }
  };
  var TREAT = {
    'sterilise-deodorise': { label: 'Sterilise & Deodorise', url: '/collections/sterilise-deodorise' },
    'professional-wash-dry': { label: 'Professional Wash & Dry', url: '/collections/professional-wash-dry' },
    'wash-reproof': { label: 'Wash & Reproof', url: '/collections/wash-reproof' }
  };

  function show(i) {
    steps.forEach(function (st, k) { st.hidden = k !== i; st.classList.toggle('is-active', k === i); });
    result.hidden = true;
    cur = i;
    bar.style.width = ((i + 1) / total * 100) + '%';
    stepNum.textContent = i + 1;
    back.hidden = i === 0;
    var legend = steps[i].querySelector('.finder__q');
    if (live && legend) live.textContent = 'Step ' + (i + 1) + ' of ' + total + '. ' + legend.textContent;
    var first = steps[i].querySelector('input');
    if (first) first.focus();
  }

  function finish() {
    var gear = GEAR[answers.item] || GEAR['outdoor-gear'];
    var treat = TREAT[answers.need] || TREAT['professional-wash-dry'];
    // Odour escalation: strong odour + not already sterilise → recommend sterilisation add-on
    var note = '';
    if (answers.odour === 'yes' && answers.need !== 'sterilise-deodorise') {
      if (answers.need === 'professional-wash-dry') note = 'Because you mentioned strong odour, add the Sterilisation Treatment (+£10) when you book for a deeper reset.';
      else note = 'For strong odour, our Sterilise & Deodorise treatment targets it at source — consider it alongside your wash.';
    }
    if (answers.odour === 'yes' && answers.need === 'professional-wash-dry') { /* keep wash, note handles upsell */ }
    if (answers.turn === 'express') {
      note += (note ? ' ' : '') + 'Need it sooner? Priority turnaround may be available on request, subject to capacity — email support@thegearspa.co.uk before booking.';
    }
    note += (note ? ' ' : '') + 'Remember: booking online reserves your service, and you bring the item to The Gear Spa in person.';
    root.querySelector('[data-finder-headline]').textContent = treat.label + ' for your ' + gear.label.toLowerCase();
    root.querySelector('[data-finder-detail]').textContent = 'Based on your answers, ' + treat.label + ' is the right fit. Here are the matching services for ' + gear.label + '.';
    var primary = root.querySelector('[data-finder-primary]');
    var secondary = root.querySelector('[data-finder-secondary]');
    primary.href = treat.url;
    primary.childNodes[0].nodeValue = 'See ' + treat.label + ' ';
    secondary.href = gear.url;
    secondary.textContent = 'Browse all ' + gear.label;
    var noteEl = root.querySelector('[data-finder-note]');
    if (note) { noteEl.textContent = note; noteEl.hidden = false; } else { noteEl.hidden = true; }
    steps.forEach(function (st) { st.hidden = true; });
    result.hidden = false;
    bar.style.width = '100%';
    stepNum.textContent = total;
    back.hidden = false;
    if (live) live.textContent = 'Recommendation ready: ' + treat.label + ' for your ' + gear.label;
    result.querySelector('h2').focus && result.querySelector('h2').setAttribute('tabindex', '-1');
    result.querySelector('h2').focus && result.querySelector('h2').focus();
  }

  root.querySelectorAll('input[type=radio]').forEach(function (input) {
    input.addEventListener('change', function () {
      answers[input.name] = input.value;
      setTimeout(function () { cur + 1 < total ? show(cur + 1) : finish(); }, 220);
    });
  });
  back.addEventListener('click', function () {
    if (!result.hidden) { show(total - 1); return; }
    if (cur > 0) show(cur - 1);
  });
  root.querySelector('[data-finder-restart]').addEventListener('click', function () {
    answers = {}; root.querySelectorAll('input[type=radio]').forEach(function (i) { i.checked = false; }); show(0);
  });
  show(0);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-services"] && !Shopify.designMode) return;
  try {
    
/* Deep-link a service option into the quote form's service select without a
   page reload when the form is on the same page. */
(function () {
  document.querySelectorAll('[data-quote-link]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var select = document.querySelector('[data-team-service-select]');
      if (!select) return;
      var wanted = link.dataset.service;
      var match = Array.prototype.find.call(select.options, function (o) { return o.value === wanted; });
      if (!match) return;
      e.preventDefault();
      select.value = wanted;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      var form = select.closest('[id]') || select;
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(function () { select.focus({ preventScroll: true }); }, 400);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
